<template>
  <div class="w-full">
    <div
        class="w-full flex text-c14 font-c4 text-left items-center item cursor-pointer"
    >
      <div class="w-1/6 text-c13">
        {{ new Date(item.created_at).toLocaleString() }}
      </div>

      <div class="w-1/6 ml-4">
        <span v-if="item.type === 'DEBIT'">-</span>
        {{ item.amount.toLocaleString() }} F
      </div>

      <div class="w-1/6 ml-4">
        <span v-if="item.method === 'CASH' || item.method === 'BANK_TRANSFER'">Espèce</span>
        <span v-if="item.method === 'MOBILE_MONEY'">Mobile Money</span>
        <span v-if="item.method === 'BANK_CHECK'">Chèque</span>
        <span v-if="item.method === 'CLIENT_ASSETS'">Wallet du client</span>
      </div>


      <div class="w-1/6 ml-4">
        <bouton
            label="Débit"
            height="30px"
            color="#F82626"
            background="#FEE9E9"
            radius="10px"
            size="12px"
            v-if="item.type === 'DEBIT'"
            class="w-1/2"
        />
        <bouton
            label="Crédit"
            height="32px"
            color="#00C24E"
            background="#E5F9ED"
            radius="10px"
            size="12px"
            v-if="item.type === 'CREDIT'"
            class="w-1/2"
        />
      </div>

      <div class="w-1/6 ml-4">
        <span v-if="item.fundedBy">{{ item.fundedBy.fullname }}</span>
        <span v-if="item.action === 'DEPOSIT_IN_BANK'">
<!--          {{item.deposit.person.fullname}}-->
          <span v-if="item.deposit.person.user.type === 'SELL'">{{ agence }}</span>
          <span v-if="item.deposit.person.user.type !== 'SELL'">COMPTABILITÉ</span>
        </span>

        <span v-if="item.action === 'PAID_ORDER'">
          <span v-if="item.receiveBy && item.receiveBy.fullname"> {{ item.receiveBy.fullname }}</span>
          <span v-if="!item.receiveBy">-</span>
        </span>

        <span v-if="item.action === 'TRANSFER_AMOUNT' ||item.action === 'RECEIVE_TRANSFER'">
<!--          <span>{{ item.transfer.person.fullname }}</span>-->
          <span v-if="item.type === 'CREDIT'">-</span>
          <span v-if="item.type === 'DEBIT'"> COMPTABILITE </span>
        </span>

        <span v-if="item.action === 'RECEIVE_WITHDRAW_AMOUNT'">
          {{ item.withdraw.person.fullname }}
        </span>

        <span v-if="item.action === 'EXPENSE'">
            COMPTABILITÉ
        </span>
      </div>

      <div class="w-1/6 ml-4">
        <span v-if="item.action === 'TRANSFER_AMOUNT' || item.action === 'RECEIVE_TRANSFER'">
          <span v-if="item.transfer.receiver">{{ item.transfer.receiver.person.fullname }}</span>
        </span>

        <span v-if="item.action === 'DEPOSIT_IN_BANK'">
          <span v-if="item.deposit">{{item.deposit.receive_bank.bankName}}</span>
        </span>

        <span v-if="item.action === 'FUND_CLIENT'">
          {{ item.client ? item.client.name : '' }} {{ item.client ? item.client.surname : ''  }}
        </span>

        <span v-if="item.action === 'RECEIVE_WITHDRAW_AMOUNT'">
          <span v-if="item.withdraw.wallet">
             {{ item.withdraw.wallet.bankName }}
          </span>

        </span>

        <span v-if="item.paidBy">
          <span v-if="item.paidBy">{{ item.paidBy.name }} {{ item.paidBy.surname }}</span>
          <span v-if="!item.paidBy">-</span>
        </span>

        <span v-if="item.action === 'EXPENSE'">
           <span v-if="!item.expense.supplier">
             {{ item.expense.categories[0] }}
           </span>

           <span v-if="item.expense.supplier">
            {{ item.expense.supplier.name }}
          </span>
        </span>
      </div>

      <div class="w-1/6 ml-4">
        <span v-if="item.action === 'FUND_CLIENT'">Accompte client</span>
        <span v-if="item.action !== 'FUND_CLIENT'">
          <span v-if="item.type === 'DEBIT' || item.action === 'RECEIVE_TRANSFER'">
            <span v-if="!item.transfer && item.action !== 'DEPOSIT_IN_BANK' && item.action !== 'EXPENSE'">-</span>
            <span v-if="item.transfer">{{ item.transfer.code }}</span>
          </span>

          <span v-if="item.action === 'PAID_ORDER'">
            <span v-if="item.order && item.order.reference">{{ item.order.reference }}</span>
            <span v-if="!item.order">-</span>
          </span>

          <span v-if="item.action === 'DEPOSIT_IN_BANK'">{{item.deposit.num}}</span>

          <span v-if="item.action === 'RECEIVE_WITHDRAW_AMOUNT'">
            {{ item.withdraw.num }}
          </span>

          <span v-if="item.action === 'EXPENSE'">
            {{ item.expense.reference }}
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import entreprise from '../../../assets/icons/entreprise.svg'
import edit from '../../../assets/icons/update.svg'
import down from '../../../assets/icons/down.svg'
import bouton from '../../helper/add/button'

export default {
  name: "Index",
  components: {
    bouton,
  },
  props: {
    item: {
      type: Object,
      default: null
    },
    agence: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      icons: {
        entreprise,
        edit,
        down
      },
    }
  },

  methods: {
    updateLine () {

    }
  },
}
</script>

<style lang="scss" scoped>
.svg-icon{
  fill: transparent;
}

.edit {
  display: none;
}

.item:hover{
  border-left: 3px groove black;
  padding-left: 30px;
}

</style>
